import { FerryLeg, FerryProduct } from '@/api/Cart/cart.interfaces';
import { isNotNil } from '@shared/utils/value';
import { isLicensePlate, isRequired } from '@ui/components/FormV2/Validations/functions';
import { FerryVehicle, FerryVehicleType } from '@shared/interfaces/ferry';
import { Validation } from '@ui/components/FormV2/Validations/Validations.interfaces';

interface FormField {
    name: string;
    validation: Validation[];
    productId: string;
}

export const getVehicleFields = (product: FerryProduct): FormField[] => {
    return [...getLicensePlateFields(product)];
};

export const getVehicleFieldName = (
    legIndex: number,
    segmentIndex: number,
    vehicleIndex: number
) => {
    return `LicensePlate-${legIndex}-${segmentIndex}-${vehicleIndex}`;
};

const getLicensePlateFields = (product: FerryProduct) => {
    return product.Legs.flatMap((leg: FerryLeg, legIndex) =>
        leg.Segments.flatMap((segment, segmentIndex) =>
            segment.Vehicles?.filter(hasLicensePlate).flatMap(
                (vehicle, vehicleIndex): FormField => ({
                    productId: product.Id,
                    validation: [isRequired, isLicensePlate],
                    name: getVehicleFieldName(legIndex, segmentIndex, vehicleIndex),
                })
            )
        )
    ).filter(isNotNil);
};

export const hasLicensePlate = (vehicle: FerryVehicle) => {
    const noPlateVehicleTypes = [FerryVehicleType.None, FerryVehicleType.Bicycle];

    return !noPlateVehicleTypes.includes(vehicle.Type);
};
